import { Controller } from 'stimulus';
import { markerIcon, popup } from '@/helpers/map';
import { uniqBy } from 'lodash';

let L;

class MapController extends Controller {
  connect() {
    MapController.loadLeaflet()
      .then((module) => {
        L = module.default;

        this.map = this.createMap();
        this.markers = [];
        this.mapMarkers = [];
        this.openMarker = null;
      })
      .then(() => this.addMarkers());
  }

  addMarkers() {
    if (this.markers.length) {
      this.markers.forEach((marker) => {
        this.map.removeLayer(marker);
      });

      this.markers = [];
    }

    const markers = L.markerClusterGroup({
      singleMarkerMode: true,
      spiderfyOnMaxZoom: false,
      showCoverageOnHover: false,
      disableClusteringAtZoom: 15,
    });

    const locations = JSON.parse(this.data.get('locations'));
    const uniqueLocations = uniqBy(locations, 'checkSum');

    uniqueLocations.forEach((location) => {
      const { latitude, longitude, checkSum } = location;
      const locationsOnLocation = locations.filter((loc) => loc.checkSum === checkSum);

      if (!latitude || latitude === '' || !longitude || longitude === '') return;

      const marker = L.marker([parseFloat(latitude), parseFloat(longitude)], {
        icon: markerIcon(location.isOffice),
      });

      marker.on('click', () => {
        this.closePopup();

        const popupElement = popup(locationsOnLocation);

        this.element.appendChild(popupElement);

        this.openMarker = marker;
      });

      markers.addLayer(marker);

      this.markers.push(marker);
    });

    this.map.addLayer(markers);
  }

  closePopup() {
    if (this.hasPopupTarget) {
      this.openMarker = null;
      this.popupTarget.parentNode.removeChild(this.popupTarget);
    }
  }

  createMap() {
    const map = L.map(this.wrapperTarget, {
      center: this.data.get('center').split(','),
      zoom: this.data.get('zoom'),
      zoomControl: false,
    });

    const mapboxTiles = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic3R2ZGJyaW5rIiwiYSI6ImNrejJqZGRydTFvd3cyb212YXVwMWF1amMifQ.SN3rZYb1w1gZzN9vnLzjWA');

    map.addLayer(mapboxTiles);

    return map;
  }

  static loadLeaflet() {
    return new Promise((resolve, reject) => {
      import(/* webpackChunkName: "leaflet" */ '../vendor/leaflet')
        .then(resolve)
        .catch(reject);
    });
  }
}

MapController.targets = [
  'map',
  'popup',
  'wrapper',
];

export default MapController;
